import type { ComponentChildren } from 'preact';
import type { PLPRoute } from '@/domain/Route';
import type { WidgetConfig } from '@/domain/WidgetConfig';
import { TranslationsProvider } from '@/widgets/hooks/useTranslations.tsx';
import { QueryStringStoreProvider } from '@/widgets/hooks/useQueryStringStore';
import { defaultOptions, defaultTranslations } from './config/index.ts';
import updateQueryState from '../utils/updateQueryState.ts';
import { WidgetOptions } from '../hooks/useWidgetOptions.tsx';
import { MediaQueryProvider } from '../hooks/useMediaQuery.tsx';
import { ABTestProvider } from '../hooks/useABTestVariant.tsx';

export type ProductListHeroBannerPageProps = {
  route: PLPRoute;
  config: WidgetConfig;
};

type ProductListHeroBannerProviderProps = ProductListHeroBannerPageProps & {
  children: ComponentChildren;
};

export const namespace = 'plhb';

export default function Providers({
  children,
  route,
  config
}: ProductListHeroBannerProviderProps) {
  return (
    <ABTestProvider>
      <WidgetOptions config={config.options} defaults={defaultOptions}>
        <TranslationsProvider
          locale={route?.locale}
          config={config.translations}
          defaults={defaultTranslations}
        >
          <QueryStringStoreProvider
            namespace={namespace}
            location={globalThis?.location}
            navigate={updateQueryState}
          >
            <MediaQueryProvider>{children}</MediaQueryProvider>
          </QueryStringStoreProvider>
        </TranslationsProvider>
      </WidgetOptions>
    </ABTestProvider>
  );
}
